import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => (
  <div dir="ltr" className="min-h-screen bg-gray-50 py-16 px-4">
    <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow p-10">
      <Link to="/" className="text-sm text-purple-600 hover:underline mb-8 inline-block">← Back to home</Link>
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Notice</h1>
      <p className="text-sm text-gray-400 mb-8">Last updated: June 2026</p>

      <section className="space-y-6 text-gray-700 text-sm leading-relaxed">
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">1. Data We Collect</h2>
          <p>When you purchase the course, we collect your name, email address, and payment information. Payment data is processed securely by Paddle and is never stored on our servers.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">2. How We Use Your Data</h2>
          <p>Your data is used solely to process your purchase, deliver course access, and send you relevant course updates. We do not use your data for advertising.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">3. Third Parties</h2>
          <p>We use Paddle as our payment processor. Paddle's privacy policy applies to payment data. We do not sell or share your personal information with any other third parties.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">4. Your Rights</h2>
          <p>You may request access to, correction of, or deletion of your personal data at any time by contacting us directly.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">5. Contact</h2>
          <p>Privacy inquiries: <a href="mailto:shovalrecruiting@gmail.com" className="text-purple-600 hover:underline">shovalhori@gmail.com</a></p>
        </div>
      </section>
    </div>
  </div>
);

export default PrivacyPage;
